import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";

import PrivateRoute from "@/components/PrivateRoute";
import Layout from "@/components/Layout";
import { MENUS } from "@/lib/rbac";

import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import UstazList from "@/pages/UstazList";
import Dashboard from "@/pages/Dashboard";
import SantriList from "@/pages/SantriList";
import SantriDetail from "@/pages/SantriDetail";
import SantriIDCard from "@/pages/SantriIDCard";
import AbsensiSantri from "@/pages/AbsensiSantri";
import AbsensiGuru from "@/pages/AbsensiGuru";
import Pelanggaran from "@/pages/Pelanggaran";
import Perizinan from "@/pages/Perizinan";
import Makan from "@/pages/Makan";
import Kegiatan from "@/pages/Kegiatan";
import Tahfiz from "@/pages/Tahfiz";
import Laporan from "@/pages/Laporan";
import Pengaturan from "@/pages/Pengaturan";
import Users from "@/pages/Users";
import Notifikasi from "@/pages/Notifikasi";
import AuditLog from "@/pages/AuditLog";
import DivisiPage from "@/pages/DivisiPage";
import DivisiTahfiz from "@/pages/DivisiTahfiz";
import Backup from "@/pages/Backup";

function Private({ children, menu }) {
  return (
    <PrivateRoute menu={menu}>
      <Layout>{children}</Layout>
    </PrivateRoute>
  );
}

function AppRoutes() {
  const location = useLocation();
  // CRITICAL: Detect Emergent OAuth callback synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/" element={<Private menu={MENUS.DASHBOARD}><Dashboard /></Private>} />
      <Route path="/santri" element={<Private menu={MENUS.SANTRI}><SantriList /></Private>} />
      <Route path="/santri/:id" element={<Private menu={MENUS.SANTRI}><SantriDetail /></Private>} />
      <Route path="/santri/:id/id-card" element={<Private menu={MENUS.SANTRI}><SantriIDCard /></Private>} />
      <Route path="/ustaz" element={<Private menu={MENUS.USTAZ}><UstazList /></Private>} />
      <Route path="/absensi-santri" element={<Private menu={MENUS.ABSENSI_SANTRI}><AbsensiSantri /></Private>} />
      <Route path="/absensi-guru" element={<Private menu={MENUS.ABSENSI_GURU}><AbsensiGuru /></Private>} />
      <Route path="/pelanggaran" element={<Private menu={MENUS.PELANGGARAN}><Pelanggaran /></Private>} />
      <Route path="/perizinan" element={<Private menu={MENUS.PERIZINAN}><Perizinan /></Private>} />
      <Route path="/makan" element={<Private menu={MENUS.MAKAN}><Makan /></Private>} />
      <Route path="/kegiatan" element={<Private menu={MENUS.KEGIATAN}><Kegiatan /></Private>} />
      <Route path="/tahfiz" element={<Private menu={MENUS.TAHFIZ}><Tahfiz /></Private>} />
      <Route path="/tahfiz-halaqah" element={<Private menu={MENUS.DIVISI_TAHFIZ}><DivisiTahfiz /></Private>} />
      <Route path="/divisi/:divisi" element={<Private><DivisiPage /></Private>} />
      <Route path="/laporan" element={<Private menu={MENUS.LAPORAN}><Laporan /></Private>} />
      <Route path="/pengaturan" element={<Private menu={MENUS.PENGATURAN}><Pengaturan /></Private>} />
      <Route path="/users" element={<Private menu={MENUS.USERS}><Users /></Private>} />
      <Route path="/notifikasi" element={<Private><Notifikasi /></Private>} />
      <Route path="/audit" element={<Private menu={MENUS.AUDIT}><AuditLog /></Private>} />
      <Route path="/backup" element={<Private menu={MENUS.BACKUP}><Backup /></Private>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
